export const TROUBLE_SHOOTING_EVENTS_TAB_LOAD_DATA = "TROUBLE_SHOOTING_EVENTS_TAB_LOAD_DATA";
export const TROUBLE_SHOOTING_EVENTS_TAB_LOAD_DATA_RESULT = "TROUBLE_SHOOTING_EVENTS_TAB_LOAD_DATA_RESULT";